import * as React from 'react';
import Box from '@mui/system/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

function OrderListLoading() {
    return (
        <Grid
            item
            xs={12}
            md={4}
            sx={{ marginTop: '44px', paddingTop: '0px !important', paddingLeft: '0px !important' }}
        >
            <Paper
                variant="outlined"
                sx={{
                    display: 'flex',
                    padding: '0px',
                    minHeight: '77vh'
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <CircularProgress />
                </Box>
            </Paper>
        </Grid>
    );
}

export default OrderListLoading;
